module.exports = __webpack_public_path__ + "static/media/platform_section2.c70a6e37.webp";